import { render, staticRenderFns } from "./major-group.vue?vue&type=template&id=202eff6d&scoped=true"
import script from "./major-group.vue?vue&type=script&lang=js"
export * from "./major-group.vue?vue&type=script&lang=js"
import style0 from "./major-group.vue?vue&type=style&index=0&id=202eff6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202eff6d",
  null
  
)

export default component.exports